module.exports = __webpack_public_path__ + "static/media/mohit.c40978b3.jfif";